import { Outlet } from "@tanstack/react-router";

import { VusionLogo } from "@/components/logos/VusionLogo";
import { ErrorBoundary } from "@/components/ErrorBoundary";

function CirclePatternBackground() {
  return (
    <svg
      className="pointer-events-none absolute inset-0 h-full w-full"
      viewBox="0 0 1440 800"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid slice"
    >
      <g opacity="0.25" clipPath="url(#clip0_bg)">
        <g filter="url(#filter0_bg)">
          <path
            d="M1565.26 1098.21C1449.62 1238.06 1289.07 1333.48 1110.96 1368.23C932.853 1402.97 748.208 1374.89 588.484 1288.77C428.76 1202.64 303.839 1063.8 235.003 895.896C166.168 727.994 157.677 541.419 210.978 367.959C264.279 194.499 376.073 44.8845 527.314 -55.3929C678.555 -155.67 859.887 -200.407 1040.41 -181.981C1220.94 -163.555 1389.49 -83.1071 1517.36 45.6576C1645.22 174.422 1724.48 343.537 1741.64 524.189C1751.49 626.77 1740.98 730.286 1710.71 828.794C1680.44 927.301 1631.01 1018.86 1565.26 1098.21Z"
            fill="#FEECE9"
          />
        </g>
        <g filter="url(#filter1_bg)">
          <path
            d="M1334.47 1032.22C1249.23 1134.96 1131.01 1204.96 999.941 1230.31C868.876 1255.66 733.075 1234.79 615.672 1171.25C498.269 1107.7 406.527 1005.43 356.072 881.833C305.617 758.241 299.572 620.978 338.965 493.428C378.358 365.878 460.753 255.93 572.114 182.313C683.476 108.696 816.915 75.9634 949.702 89.6917C1082.49 103.42 1206.41 162.76 1300.36 257.603C1394.3 352.446 1452.46 476.925 1464.92 609.837C1472.09 685.364 1464.25 761.562 1441.86 834.05C1419.47 906.538 1382.98 973.885 1334.47 1032.22Z"
            fill="#FEECE9"
          />
        </g>
        <g filter="url(#filter2_bg)">
          <path
            d="M1038.02 977.533C993.608 1031.12 931.995 1067.64 863.674 1080.9C795.354 1094.15 724.552 1083.3 663.33 1050.21C602.109 1017.11 554.255 963.818 527.92 899.399C501.585 834.981 498.399 763.424 518.904 696.919C539.41 630.415 582.338 573.077 640.376 534.672C698.414 496.268 767.972 479.173 837.2 486.301C906.428 493.428 971.043 524.336 1020.04 573.76C1069.04 623.184 1099.38 688.066 1105.91 757.353C1109.62 796.715 1105.54 836.423 1093.89 874.205C1082.24 911.986 1063.26 947.099 1038.02 977.533Z"
            fill="#FEECE9"
          />
        </g>
      </g>
      <defs>
        <filter id="filter0_bg" x="176.379" y="-186.037" width="1568.84" height="1568.78" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="108.631" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.980392 0 0 0 0 0.380392 0 0 0 0 0.298039 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter id="filter1_bg" x="313.266" y="86.6309" width="1154.23" height="1154.18" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="108.631" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.980392 0 0 0 0 0.380392 0 0 0 0 0.298039 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <filter id="filter2_bg" x="505.549" y="484.718" width="601.688" height="601.683" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feGaussianBlur stdDeviation="83.5622" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.980392 0 0 0 0 0.380392 0 0 0 0 0.298039 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <clipPath id="clip0_bg">
          <rect width="1592.2" height="1592.44" fill="white" transform="translate(-160.366 705.895) rotate(-50.4569)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PublicLayout() {
  return (
    <main className="relative flex h-screen flex-col items-center justify-between overflow-y-auto bg-pink-50 px-6 pb-6 pt-6 sm:pt-16">
      <CirclePatternBackground />
      <div className="relative z-10 shrink-0 lg:self-start lg:pl-6">
        <VusionLogo />
      </div>
      <div className="relative z-10 flex h-full grow items-center">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </div>
    </main>
  );
}
